import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
} from '@mui/material';
import { Iconify } from 'src/components/iconify';
import { BubbleMenuItem } from '../EditorBubbleMenu/types';

export const AiPromptPopOver = ({
  submenuItems,
  anchorEl,
  onClose,
}: {
  submenuItems: BubbleMenuItem[];
  anchorEl: HTMLElement | null;
  onClose: () => void;
}) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      sx={{
        zIndex: 'tooltip',
      }}
    >
      <MenuList>
        {submenuItems.map((subItem) => (
          <MenuItem key={subItem.name} onClick={subItem.command}>
            <ListItemIcon>
              <Iconify icon={subItem.icon} />
            </ListItemIcon>
            <ListItemText>{subItem.name}</ListItemText>
          </MenuItem>
        ))}
      </MenuList>
    </Popover>
  );
};
